import { render, staticRenderFns } from "./DefaultComp.vue?vue&type=template&id=af978122&"
import script from "./DefaultComp.vue?vue&type=script&lang=js&"
export * from "./DefaultComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports